import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AppTeam} from '@shared/models/team';
import {AppLeague} from '@shared/models/league';
import {UserService} from '@core/services/user.service';
import {LinkService} from '@core/services/link.service';
import {Subscription} from 'rxjs';
import {User} from '@shared/models/user';
import {EntityType} from '@lib/models/entity/entity-type';
import {FollowService} from '@core/services/follow/follow.service';

@Component({
  selector: 'app-my-team-league-cell',
  templateUrl: './my-team-league-cell.component.html',
  styleUrls: ['./my-team-league-cell.component.scss']
})
export class MyTeamLeagueCellComponent implements OnInit, OnDestroy {
  @Input() team: AppTeam = null;
  @Input() league: AppLeague = null;

  @Output() onFollow = new EventEmitter<void>();
  @Output() onUnFollow = new EventEmitter<void>();

  private userSubj: Subscription;
  public userAlreadyFollowsTeamOrLeague = false;

  public link = '';
  public emblem = '';
  public name = '';


  constructor(
    private userService: UserService,
    private followService: FollowService,
  ) { }

  ngOnInit() {
    if (this.team != null) {
      this.name = this.team.name;
      this.emblem = this.team.getLogoImageUrl('big');

      const link = LinkService.getTeamLink(this.team.readable_id);
      if (link != null) {
        this.link = link.toString();
      }
    } else if (this.league != null) {
      this.name = this.league.name;
      this.emblem = this.league.getLogoImageUrl('big');

      const link = LinkService.getLeagueLink(this.league.readable_id);
      if (link != null) {
        this.link = link.toString();
      }
    }

    if (this.userService.currentUser != null) {
      this.checkIfUserFollowsTeamOrLeague(this.userService.currentUser);
    }

    this.userSubj = this.userService.currentUserSubject.subscribe(user => {
      if (!user) {
        return;
      }
      this.checkIfUserFollowsTeamOrLeague(user);
    })
  }

  ngOnDestroy() {
    this.userSubj.unsubscribe();
  }

  private checkIfUserFollowsTeamOrLeague(user: User) {
    if (this.team != null) {
      this.userAlreadyFollowsTeamOrLeague = this.followService.userFollows(EntityType.Team, this.team.id);
    } else if (this.league != null) {
      this.userAlreadyFollowsTeamOrLeague = this.followService.userFollows(EntityType.League, this.league.id);
    }
  }

  public async toggleFollow(follow: boolean) {
    if (this.team != null) {
      await this.followService.toggleFollow(follow, EntityType.Team, this.team.name, this.team.id);
    }
    if (this.league != null) {
      await this.followService.toggleFollow(follow, EntityType.League, this.league.name, this.league.id);
    }

    if (follow) {
      this.onFollow.emit();
    } else {
      this.onUnFollow.emit();
    }
  }
}
